// extracted by mini-css-extract-plugin
export default {"inline-navigation":"InlineNavigation_inline-navigation__Jd27+","anchor-tag--image":"InlineNavigation_anchor-tag--image__F4wWc"};